import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取批量信息
export const getCustomerWithSKU = () => {
  return axios.request({
    url: "/api/mock/customer",
    method: "GET",
  });
};

export const publishTask = (params) => {
  return axios.request({
    url: "/api/mock/publishTask",
    method: "POST",
    params
  })
}

export const getMatchedSKU = (params) => {
  return axios.request({
    url: `/api/mock/matchedSKU?id=${params}`,
    method: "GET",
  })
}

export const getClientViaShipmentOrders = (params) => {
  return axios.request({
    url: `/api/mock/findClient?shipmentNumber=${params}`,
    method: "GET",
  })
}

export const createMockPackage = (params) => {
  return axios.request({
    url: "/api/mock/mockPackage",
    method: "POST",
    params
  })
}

export const fetchSummary = (params) => {
  return axios.request({
    url: "/api/mock/summary?key=" + params,
    method: "GET",
  })
}

export const exportSummary = (params) => {
  return axios.request({
    url: "/api/mock/exportSummary?key=" + params,
    method: "GET",
  })
}
